export default __webpack_public_path__ + "static/16-df6157a00d647b09c670e4864f53c987.jpg";